import React, { Suspense } from 'react';

import LoadingImage from './LoadingImage';

// when uploading the new version, old chunks will be
// deleted. auto refresh page when user tries to request
// the old chunk. So the page does not crash anymore

interface Props {
  children: React.ReactNode;
}

interface States {
  hasError: boolean;
}

class LazyLoadErrorBoundary extends React.Component<Props, States> {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    if (error.toString().includes('Loading chunk')) {
      window.location.reload();
      return { hasError: true };
    } else {
      throw error;
    }
  }

  render() {
    if (this.state.hasError) {
      return null;
    }

    return this.props.children;
  }
}

type LazyPageLoaderFn = <T>(
  LazyComponent: React.ComponentType<T>
) => React.ComponentType<T>;

const LazyPageLoader: LazyPageLoaderFn = LazyComponent => props => {
  return (
    <LazyLoadErrorBoundary>
      <Suspense fallback={<LoadingImage displayAsBlock loading />}>
        <LazyComponent {...props} />
      </Suspense>
    </LazyLoadErrorBoundary>
  );
};

export default LazyPageLoader;
